<template>
    <div class="mh-card-subheader" @click="action" :class="{'clickable': clickable}">
        <div class="columns">
            <div class="column">
                <b-icon :icon="icon" class="fa-fw" v-if="icon"></b-icon>{{title}}
            </div>
            <div class="column" v-if="badge">
                <b-tag>{{badge}}</b-tag>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CardSubheader',
        props: {
            title:  String,
            icon: String,
            badge: [String, Number],
            clickable: Boolean
        },
        methods: {
            action: function() {
                if (this.clickable) this.$emit('action');
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/variables';

    $color: #708190;

    .mh-card-subheader {
        background-color: $color !important;
        padding: 7px 20px 7px 10px !important;
        border-bottom: 1px solid $color !important;

        cursor: auto !important;

        .title {
            font-family: 'Montserrat', sans-serif;
            color: white;
            text-transform: uppercase;
            font-size: 0.75rem;
            font-weight: bold;
            letter-spacing: 0.5px;
        }

        .badge-label, .badge-column {
            font-size: 0.67rem;
            color: #504f4f !important;
        }

        i {
            font-size: 0.8rem;
            margin-right: $list-icon-margin-right;
        }

        &:hover {
            background-color: $color !important;
        }

        &.clickable {
            cursor: pointer;
        }
    }
</style>
